// Hook for monitoring online/offline status and triggering sync
import { useEffect } from 'react'
import useSurveyStore from '../stores/surveyStore'

/**
 * Hook to monitor connectivity and auto-sync when coming back online
 * Should be used in the root App component
 */
export function useConnectivity() {
  const setOnlineStatus = useSurveyStore(state => state.setOnlineStatus)
  const refreshPendingCount = useSurveyStore(state => state.refreshPendingCount)
  const isOnline = useSurveyStore(state => state.isOnline)
  const pendingUploads = useSurveyStore(state => state.pendingUploads)
  const pendingSurveys = useSurveyStore(state => state.pendingSurveys)
  const syncing = useSurveyStore(state => state.syncing)
  const syncingSurveys = useSurveyStore(state => state.syncingSurveys)

  useEffect(() => {
    // Initial check
    setOnlineStatus(navigator.onLine)
    refreshPendingCount()

    // Listen for connectivity changes
    const handleOnline = () => {
      console.log('Connection restored - syncing pending photos...')
      setOnlineStatus(true)
    }

    const handleOffline = () => {
      console.log('Connection lost - photos will be saved locally')
      setOnlineStatus(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [setOnlineStatus, refreshPendingCount])

  return { isOnline, pendingUploads, pendingSurveys, syncing, syncingSurveys }
}

export default useConnectivity
